import { MapContainer, Marker, Popup, TileLayer, useMap, useMapEvent } from "react-leaflet"
import { useEffect, useState } from "react"
import ExifReader from 'exifreader';
import axios from "axios";

const errcodes = ["lime", "orange", "red", "red", "lime"]

const Editor = () => {

    const Signin = () => {

        const [username, setUsername] = useState('')
        const [password, setPassword] = useState('')
        const [userstat, setUserstat] = useState('')

        const sendSignReq = () => {
            const data = {"username": username, "password": password}
            axios.post('https://nexsu.arina.lol/api/win7/signin', data).then((res, err) => {
                if (err) return console.error(err)
                if (res.status > 300) {
                    setUserstat(`Error! ${res.status} - ${res.data}`)
                } else {
                    setUserstat('Signed in!')
                }
                localStorage.setItem('username', res.data.username)
                localStorage.setItem('password', res.data.sesk) //can we stop calling it different things lol
            })
        }

        return (
            <div style={{display: 'flex'}}>
                <input type="text" placeholder="Username" value={username} onChange={(e) => setUsername(e.currentTarget.value)} />
                <input type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.currentTarget.value)} />
                <button onClick={() => sendSignReq()}>Sign In</button>
                <p>{userstat}</p>
            </div>
        )
    } //user signs in but the page remains static. this simply sets your session key and allows your actions sent to the server to mean something

    const MapEditor = () => {

        const MarkerSetter = () => {

            const [location, setLocation] = useState([0, 0])
            const [markerdata, setMarkerdata] = useState({
                "title": "",
                "description": "",
                "type": "supercell",
                "prefix": "",
                "folder": 6,
                "camera": {
                    'camera': 'NIKON D810', 
                    'dim': '', 
                    'ap': '', 
                    'exp': '', 
                    'iso': '', 
                    'mm': '', 
                    'size': ''
                },
                "public": null,
                "dateA": "2025-04-21",
                "time": "00:00:00",
                "filters": ""
            })
            const [thumb, setThumb] = useState(null)
            const [imgfile, setImgFile] = useState(null)
            const [attempts, setAttempts] = useState(0)
            const [err, setErr] = useState({code: 0, text: ""})
            const [progress, setProgress] = useState(["░","░","░","░","░","░","░","░","░","░"])

            useMapEvent('contextmenu', (e) => {            
                setLocation([e.latlng.lat, e.latlng.lng])
            })

            const handleFileChange = (event) => {
              const file = event.target.files[0];
              setImgFile(file)
        
              if (file) {
                const reader = new FileReader();
        
                reader.onload = async (e) => {
                    const tags = await ExifReader.load(file);
                    if ("Model" in tags) {
                        const cameraDetails = {
                            'camera': `${tags['Model'].description}`,
                            'dim': `${tags['Image Width'].description}x${tags['Image Height'].description}`,
                            'ap': `f/${tags['ApertureValue'].description}`,
                            'exp': `${tags['ShutterSpeedValue'].description}`,
                            'iso': `${tags['ISOSpeedRatings'].description}`,
                            'mm': `${tags['FocalLength'].description}`,
                            'size': `${(file.size / 1000000)}MB`
                        }
                        if ("GPSLatitude" in tags) {
                            setLocation([tags['GPSLatitude'].description, (tags['GPSLongitude'].description * -1)])
                            setErr({code: 4, text: "GPS Data found! Setting exact location."})
                        }
                        setMarkerdata({
                            "title": markerdata.title,
                            "description": markerdata.description,
                            "type": markerdata.type,
                            "prefix": markerdata.prefix,
                            "folder": markerdata.folder,
                            "camera": cameraDetails,
                            "public": markerdata.public,
                            "dateA": (tags[`Date Created`] in tags ? `${tags['Date Created'].description}` : `${tags['DateTimeOriginal'].description.substring(0, 10).replaceAll(':', '-')}`),
                            "time":  (tags[`Time Created`] in tags ? `${tags['Time Created'].description}` : `${tags['DateTimeOriginal'].description.substring(11)}`)
                        })
                        const blob = new Blob([tags['Thumbnail'].image], { type: `${file.type}` });
                        const imageUrl = URL.createObjectURL(blob);
                        setThumb(imageUrl)
                    } else {
                        if ("Thumbnail" in tags) {
                            const blob = new Blob([tags['Thumbnail'].image], { type: `${file.type}` });
                            const imageUrl = URL.createObjectURL(blob);
                            setThumb(imageUrl)
                            setErr({code: 2, text: "EXIF Data missing 'Model' tag, so it's likely missing all the camera details. Cannot auto-set but will upload fine."})
                            return
                        } else {
                            setErr({code: 3, text: "EXIF Data missing 'Model' AND 'Thumbnail' tag. Cannot auto-set or preview, but will upload fine."})
                            return
                        }
                    }
                };
                reader.readAsDataURL(file);
              }
            };
        
            const onSubmit = (e) => {
                e.preventDefault();
                const username = localStorage.getItem("postUsername")
                const password = localStorage.getItem("password")

                const data = new FormData();
                data.append('file', imgfile)
                data.append('username', username)
                data.append('sesk', password)
                data.append('coordinates', `[${location.reverse()[0]}, ${location[1]}]`)
                
                var ck = 0
                Object.keys(markerdata).forEach((el) => {
                    if (markerdata[`${el}`] === null) ck++;
                    if (el === 'camera') {
                        data.append(`${JSON.stringify(el)}`, markerdata[`${el}`])
                    } else {
                        data.append(`${el}`, markerdata[`${el}`])
                    }
                })

                if (attempts == 0 && (!imgfile || ck >= 1)) {
                    setAttempts(1)
                    return setErr({code: 1, text: "One or more fields are empty! Are you sure you want to continue? (Press again to proceed)"})
                }
        
                const config = {
                    headers: {'content-type': "multipart/form-data"},
                    onUploadProgress: (progressEvent) => {
                        const prog = (progressEvent.loaded / progressEvent.total) * 100;
                        var p = ["░","░","░","░","░","░","░","░","░","░"];
                        p.forEach((el, ind) => {
                            if ((prog / 10) >= ind) p[ind] = "▓"
                        })
                        setProgress(p)
                        if (progress >= 50) {
                            setErr({code: 0, text: "File uploaded and marker placed!"})
                        }
                    }
                }

                axios.post("https://nexsu.arina.lol/api/win7/create", data, config).then((res, err) => {
                    if (res.status >= 400) {
                        setErr({code: 2, text: 'Failed. Probably need to re-login.'})
                    }
                    setAttempts(0)
                    setMarkerdata({
                        "title": "",
                        "description": "",
                        "type": markerdata.type,
                        "prefix": markerdata.prefix,
                        "folder": markerdata.folder,
                        "camera": {
                            'camera': `${markerdata.camera.camera}`, 
                            'dim': '', 
                            'ap': '', 
                            'exp': '', 
                            'iso': '', 
                            'mm': '', 
                            'size': ''
                        },
                        "public": markerdata.public,
                        "dateA": markerdata.dateA,
                        "time": markerdata.time
                    })
                    setImgFile(null)
                    setThumb(null)
                    setProgress(["░","░","░","░","░","░","░","░","░","░"])
                })
            };

            return (
                <Marker position={location}>
                    <Popup>
                        <div>
                            <img src={thumb} width={'100%'} height={'100%'} />
                            <input onChange={handleFileChange} type="file" />
                            <p style={{color: `${errcodes[err.code]}`}}>{err.text}</p>
                            <p id="uploading-bar" style={{fontSize: '24px', margin: 0, padding: 0}}>[{progress}]</p>
                            <hr/>
                            <div style={{display: 'grid', gridTemplateColumns: '50% 50%', justifyContent: 'center'}}>
                                <input value={markerdata.dateA} onChange={(e) => setMarkerdata(st => ({ ...st, ['dateA']: `${e.target.value}`}))} type="date" />
                                <input value={markerdata.time} onChange={(e) => setMarkerdata(st => ({ ...st, ['time']: `${e.target.value}`}))} type="time" />
                                <input value={location[0]} onChange={(e) => setLocation(e.target.value === '' ? 0 : ([e.target.value, location[1]]))} type="text" />
                                <input value={location[1]} onChange={(e) => setLocation(e.target.value === '' ? 0 : ([location[0], e.target.value]))} type="text" />
                            </div>
                            <div style={{display: 'grid', gridTemplateColumns: '50% 50%', width: 'calc(100% - 14px)', border: 'double black 2px', margin: '5px'}}>
                                <select value={markerdata.camera.camera} onChange={(e) => setMarkerdata(st => ({ ...st, ['camera']: {...st.camera, camera: `${e.target.value}`}}))} >
                                    <option value={"NIKON D810"}>📷Nikon D810</option>
                                    <option value={"DJI FPV"}>🚁DJI FPV</option>
                                    <option value={"Sony AX100"}>📹Sony AX100</option>
                                    <option value={"NIKON D7000"}>📷Nikon D7000</option>
                                    <option value={"GoPro Hero 12"}>📷GoPro Hero 12</option>
                                    <option value={"SM-G991U1"}>📱Samsung Galaxy S21</option>
                                    <option value={"Other"}>Other</option>
                                </select>
                                <input value={markerdata.camera.ap} onChange={(e) => setMarkerdata(st => ({ ...st, ['camera']: {...st.camera, ap: `${e.target.value}`}}))} type="text" placeholder="Aperature" />
                                <input value={markerdata.camera.exp} onChange={(e) => setMarkerdata(st => ({ ...st, ['camera']: {...st.camera, exp: `f/${e.target.value}`}}))} type="text" placeholder="Exposure"/>
                                <input value={markerdata.camera.iso} onChange={(e) => setMarkerdata(st => ({ ...st, ['camera']: {...st.camera, iso: `${e.target.value}`}}))} type="text" placeholder="Iso" />
                                <input value={markerdata.camera.mm} onChange={(e) => setMarkerdata(st => ({ ...st, ['camera']: {...st.camera, mm: `${e.target.value}mm`}}))} type="text" placeholder="Focus Length (mm)" />
                                <input value={markerdata.camera.size} onChange={(e) => setMarkerdata(st => ({ ...st, ['camera']: {...st.camera, size: `${e.target.value}MB`}}))} type="text" placeholder="Size (MB with 2 decimal places)" />
                            </div>
                            <hr/>
                            <div style={{display: 'grid', gridTemplateColumns: '50% 50%'}}>
                                <div>
                                    <input style={{width: '90%'}} onChange={(e) => setMarkerdata(st => ({ ...st, ['title']: `${e.target.value}`}))} value={markerdata.title} type="text" placeholder="Title"/>
                                    <textarea style={{width: '90%'}} onChange={(e) => setMarkerdata(st => ({ ...st, ['description']: `${e.target.value}`}))} placeholder="Description" />
                                </div>
                                <div>
                                    <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                                        <label htmlFor="markertype">
                                            <img src={`/images/markers/${markerdata.prefix}${markerdata.type}-marker.png`} style={{imageRendering: 'pixelated'}} width={`${markerdata.prefix == "" ? '25px' : '35px'}`} height={`${markerdata.prefix == "" ? '25px' : '35px'}`} />
                                        </label>
                                        <select id="markertype" value={markerdata.prefix} defaultValue={""} onChange={(e) => setMarkerdata(st => ({ ...st, ['prefix']: `${e.target.value}`}))} >
                                            <option value={""}>Photo</option>
                                            <option value={"v-"}>Video</option>
                                            <option value={"t-"}>Timelapse</option>
                                        </select>
                                        <select id="markertype" value={markerdata.type} defaultValue={"supercell"} onChange={(e) => setMarkerdata(st => ({ ...st, ['type']: `${e.target.value}`}))} >
                                            <option value={"supercell"}>Supercell</option>
                                            <option value={"tornado"}>Tornado</option>
                                            <option value={"shelf"}>Shelf</option>
                                            <option value={"lightning"}>Lightning</option>
                                            <option value={"clouds"}>Clouds</option>
                                            <option value={"aurora"}>Aurora</option>
                                            <option value={"landscape"}>Landscape</option>
                                            <option value={"wildlife"}>Wildlife</option>
                                            <option value={"other"}>Other</option>
                                        </select>
                                    </div>
                                    <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                                        <p>📁: </p>
                                        <select id="markerfolder" value={markerdata.folder} onChange={(e) => setMarkerdata(st => ({ ...st, ['folder']: `${e.target.value}`}))} >
                                            <option value={5}>⭐Featured</option>
                                            <option value={6}>📷Pictures</option>
                                            <option value={7}>📹Videos</option>
                                            <option value={20}>🌪Stormchasing</option>
                                            <option value={8}>🌌Space & Auroras</option>
                                            <option value={17}>📱Mobile Backgrounds</option>
                                            <option value={10}>Other</option>
                                        </select>
                                    </div>
                                    <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                                        <img src="/images/bgs/bauble.png" height={'20px'} width={'20px'} />                                        
                                        <select value={markerdata.public} onChange={(e) => setMarkerdata(st => ({ ...st, ['public']: `${e.target.value}`}))} >
                                            <option value={null}>No Bauble</option>
                                            <option value={0}>🟣Featured</option>
                                            <option value={1}>🟢New</option>
                                            <option value={2}>🔵Updated</option>
                                            <option value={3}>🔵Old img, new upload</option>
                                            <option value={4}>🔴Expiring</option>
                                            <option value={5}>🟠Large File Warn</option>
                                            <option value={6}>🟤Raw Image Type</option>
                                            <option value={7}>🟡Personal Favorite</option>
                                        </select>
                                    </div>
                                    <input style={{width: '90%'}} onChange={(e) => setMarkerdata(st => ({ ...st, ['filters']: `${e.target.value}`}))} value={markerdata.filters} type="text" placeholder="Filters (il,illinois,2025,march,poplar)"/>
                                </div>
                                <p style={{fontSize: '12px', gridColumn: 'span 2'}}>Note 1: Time must be in 5 minute intervals (ex. 11:32:50 = 11:30:00).</p>
                                <p style={{fontSize: '12px', gridColumn: 'span 2'}}>Note 2: Markers have to be approved before appearing.</p>
                                <p style={{fontSize: '12px', gridColumn: 'span 2'}}>Note 3: Images can be moved into lower folders after adding.</p>
                                <button style={{gridColumn: 'span 2', margin: '20px'}} onClick={(e) => onSubmit(e)}>📌 Add Marker</button>
                            </div>
                        </div>
                    </Popup>
                </Marker>
            )
        }

        return (
            <MapContainer style={{height: '100%'}} center={[41, -88]} zoom={4} scrollWheelZoom={true}>
                <TileLayer
                    attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
                    url="https://tile.openstreetmap.org/{z}/{x}/{y}.png"
                />
                <MarkerSetter/>
            </MapContainer>
        )
    }

    return (
        <>
            <Signin/>
            <div style={{height: '90vh', width: '100vw'}}>
                <div style={{height: '100%', width: '100%'}}>
                    <MapEditor/>
                </div>
            </div>
        </>
    )
}

export default Editor;